import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { server } from "../server";


const ActivationPage = () => {
  const { activation_token } = useParams();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Your token is expired!");
  const [successMessage, setSuccessMessage] = useState("Your account has been created successfully!");
  const [activatedUser, setActivatedUser] = useState(null);

  useEffect(() => {
    if (activation_token) {
      const sendRequest = async () => {
        try {
          const response = await axios.post(`${server}/user/activation`, {
            activation_token,
          });

          setSuccessMessage(
            response.data?.message || "Your account has been created successfully!"
          );
          setActivatedUser(response.data?.user || null);
        } catch (err) {
          setError(true);
          setErrorMessage(err.response?.data?.message || "Your token is expired!");
        }
      };
      sendRequest();
    }
  }, [activation_token]);

  return (
    <div className="activation-page">
      {error ? (
        <p>{errorMessage}</p>
      ) : (
        <>
          <p>{successMessage}</p>
          {activatedUser?.uniqueId ? (
            <div style={{ margin: "1.5rem auto", maxWidth: "22rem", textAlign: "center" }}>
              <p>
                <strong>Unique ID:</strong> {activatedUser.uniqueId}
              </p>
              {activatedUser.qrCodeUrl ? (
                <img
                  src={activatedUser.qrCodeUrl}
                  alt="Your BuzzVibe QR code"
                  style={{ width: "220px", height: "220px", objectFit: "contain", margin: "1rem auto" }}
                />
              ) : null}
            </div>
          ) : null}
          <Link to="/login">
            <button className="activation-signin-button">
              Sign In
            </button>
          </Link>
        </>
      )}
    </div>
  );
};

export default ActivationPage;
